import api from './Api';

export interface InventoryResult {
  items: Record<string, string | number | null>[];
  hasMore: boolean;
  coverage: string;
}
export interface ChatReply { answer: string; mode: 'lookup' | 'ai'; action: string; data: InventoryResult | null; sources?: { tool: string; data: InventoryResult }[] }
export interface ChatMessage { role: 'user' | 'assistant'; content: string; reply?: ChatReply }
export interface ChatCompany { id: number; name: string }
export interface ChatStatus { configured: boolean; canQuery: boolean }

const readConfig = (signal: AbortSignal) => ({ signal, headers: { 'Cache-Control': 'no-store' }, suppressGlobalError: true });
export const AssistantApi = {
  dailySales: (params: { companyId?: number; depositId?: number; from: string; to: string }, signal: AbortSignal) => api.get<InventoryResult>('/ai/daily-sales', { ...readConfig(signal), params }),
  status: (signal: AbortSignal) => api.get<ChatStatus>('/ai/status', readConfig(signal)),
  companies: (signal: AbortSignal) => api.get<ChatCompany[]>('/ai/companies', readConfig(signal)),
  deposits: (companyId: number | undefined, signal: AbortSignal) => api.get<InventoryResult>('/ai/deposits', { ...readConfig(signal), params: { companyId } }),
  send: (request: { companyId?: number; depositId?: number; message: string; language: string; action?: string; history: ChatMessage[] }, signal: AbortSignal) =>
    api.post<ChatReply>('/ai/chat', request, { signal, timeout: 300000, suppressGlobalError: true }),
};
